import React from "react";
import { connect } from "react-redux";
import GrComponentFactory from "../gr_component_factory";
import { values } from "lodash";
import { toggleSearch } from "../../react_actions/header/search_actions";
import { acknowledgeEvent } from "../../modules/shared/touch_not_ready_helper";
import classNames from "classnames";
import SearchExperienceIcon, {
  searchExperiencePresentationType,
} from "./search_experience_presentation";

export const SEARCH_TOGGLE_TYPES = {
  ICON: "icon",
  CANCEL: "Cancel",
};

export const component = GrComponentFactory.createClass({
  displayName: "SearchToggle",

  propTypes: {
    searchIsActive: React.PropTypes.bool.isRequired,
    toggleType: React.PropTypes.oneOf(values(SEARCH_TOGGLE_TYPES)),
    onToggleSearch: React.PropTypes.func.isRequired,
  },

  contextTypes: {
    searchExperiencePresentation: searchExperiencePresentationType,
  },

  getDefaultProps() {
    return { searchIsActive: false };
  },

  toggleSearch(event) {
    acknowledgeEvent(event);
    return this.props.onToggleSearch(!this.props.searchIsActive);
  },

  hideSearch() {
    return this.props.onToggleSearch(false);
  },

  render() {
    const presentation = this.context.searchExperiencePresentation;
    const iconPresentation = presentation && presentation.icon;
    const icon = iconPresentation &&
      iconPresentation.icons &&
      iconPresentation.icons["header-toggle"];
    const iconClassName = classNames(
      "siteHeader__searchIcon gr-iconButton",
      icon && iconPresentation.containerClassName);

    switch (this.props.toggleType) {
      case SEARCH_TOGGLE_TYPES.ICON:
        return <button className={iconClassName}
                       onClick={this.toggleSearch}
                       aria-label="Toggle search"
                       type="button"
                       data-ux-click>
                 <SearchExperienceIcon
                   placement="header-toggle"
                   presentation={presentation} />
               </button>;
      case SEARCH_TOGGLE_TYPES.CANCEL:
        return (
          <button className="gr-buttonAsLink"
                  onClick={this.hideSearch}
                  aria-label="Hide search"
                  type="button">
            {SEARCH_TOGGLE_TYPES.CANCEL}
          </button>
        );
      default:
        return null;
    }
  },
});

export const mapStateToProps = (state, ownProps) => Object.assign({}, ownProps, state);

export const mapDispatchToProps = (dispatch) => ({
  onToggleSearch: (searchIsActive) => dispatch(toggleSearch(searchIsActive)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(component);
